import {
  useContext,
} from 'react';
import styled from "styled-components";

import { ThemeContext } from '@dstantwo/ullr-react-components';

export const LoginInputStyled = styled.input`
  border: 2px solid #EBEAED;

  font-size: 20px;
  height: 60px;
  width: 100%;
  font-weight: 600;

  color: #919DAB;

  border-radius: 30px;
  transition: border-color 0.3s;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: top;
  padding: 0 25px;

  outline: none;
  background: transparent;
  resize: none;
  overflow: visible;
`;

export const ErrorText = styled.span`
  font-size: 16;
  font-weight: bold;
  color: ${() => useContext(ThemeContext).COLORS.RED_ALERT};
  margin-top: 8px;
  margin-left: 24px;
`;

export const LoginInputContainer = styled.div`
  width: 100%;  
  margin-bottom: 20px;
`;